import { LOGIN_TYPE_ADMLIMITED } from "Constants";
import { STORE_KEY_LOGIN_TYPE, storeGet } from "mailup-react-helpers";
import {
  Actions,
  Badge,
  DataListExtraColumn,
  DataListRow,
  Grid,
  GridCell,
  Text,
  TruncateAndTooltip,
} from "mailup-web-components";
import React, { useCallback, type FC } from "react";
import { useIntl } from "react-intl";
import { useRecoilCallback, useSetRecoilState } from "recoil";
import { EXTRA_COLUMN_AFTER_WIDTH } from "../model";
import { downloadImportFileCallback } from "../recoil/callbacks";
import { modalDelesteImpostsState } from "../recoil/state";
import { gainsightTrack } from "mailup-react-helpers";

interface ToImportTableRowProps {
  item: any;
}

const ToImportTableRow: FC<ToImportTableRowProps> = ({ item }) => {
  const intl = useIntl();
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE);
  const setModalDelete = useSetRecoilState(modalDelesteImpostsState);
  const downloadImportFile = useRecoilCallback(downloadImportFileCallback, []);

  function onClickDownload() {
    gainsightTrack("mup_importStatusPage_clickDownloadMenuFileImporting", {});

    downloadImportFile(item.Filename, item.Id);
  }

  function onClickDelete() {
    gainsightTrack("mup_importStatusPage_clickDeleteMenuFileImporting", {});

    setModalDelete((_prev) => ({
      show: true,
      title: intl.formatMessage(
        {
          id: "Load.FileImportStatus.ModalDeleteSingleTitle",
        },
        {
          NAME: item.Filename,
        },
      ),
      descr: intl.formatMessage({
        id: "Load.FileImportStatus.ModalDeleteDescr",
      }),
      id: item.Id,
      source: "toImportTable",
    }));
  }

  function setItemsAction() {
    const itemsAction = [];
    if (loginType !== LOGIN_TYPE_ADMLIMITED) {
      itemsAction.push({
        label: intl.formatMessage({
          id: "Load.FileImportStatus.DownloadAction",
        }),
        onClick: onClickDownload,
      });
    }
    if (item.Status === 1) {
      itemsAction.push({
        onClick: onClickDelete,
        label: intl.formatMessage({
          id: "Load.FileImportStatus.DeleteAction",
        }),
      });
    }
    return itemsAction;
  }

  return (
    <DataListRow>
      <Grid cols={12}>
        <GridCell span={4}>
          <Text variant="light">
            <TruncateAndTooltip text={item.Filename} />
          </Text>
        </GridCell>
        <GridCell span={4}>
          <Text variant="light">
            {`${intl.formatNumber(item.FileSize / 1024)} KB`}
          </Text>
        </GridCell>
        <GridCell span={4}>
          <Badge
            text={intl.formatMessage({
              id:
                item.Status === 1
                  ? "Load.FileImportStatus.ToImport"
                  : "Load.FileImportStatus.InProgressState",
            })}
            type={item.Status === 1 ? "default" : "info"}
          />
        </GridCell>
      </Grid>
      <DataListExtraColumn after width={EXTRA_COLUMN_AFTER_WIDTH}>
        <Actions items={setItemsAction()} />
      </DataListExtraColumn>
    </DataListRow>
  );
};

export default ToImportTableRow;
